export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, { method = "GET", body, form } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    ...(form
      ? { body: form }
      : body !== undefined
        ? { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }
        : {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Errore di rete");
  return data;
}

export const imgUrl = (src) =>
  !src ? "" : src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);
